import React from "react";
import { User } from "../../../api/usersApi";
import { ConfirmationDialog } from "../../../components/common/ConfirmationDialog/ConfirmationDialog";

interface ArchiveUserDialogProps {
  open: boolean;
  user: User | null;
  mode: "archive" | "restore";
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

const ArchiveUserDialog: React.FC<ArchiveUserDialogProps> = ({
  open,
  user,
  mode,
  onClose,
  onConfirm,
  isLoading,
}) => {
  const isArchive = mode === "archive";
  const fullName = `${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim();

  return (
    <ConfirmationDialog
      open={open}
      title={isArchive ? "Archive User" : "Restore User"}
      message={
        isArchive
          ? `Are you sure you want to archive "${fullName}"? They will be moved to the Archived tab and will not be able to log in.`
          : `Are you sure you want to restore "${fullName}"? They will be moved back to the active list.`
      }
      confirmLabel={isArchive ? "Archive" : "Restore"}
      confirmColor={isArchive ? "warning" : "success"}
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
    />
  );
};

export default ArchiveUserDialog;
